'use client'

import { createContext } from 'react';
import type { ResourceConfig } from '../interfaces/ResourceConfig';

/**
 * @group Contexts

@summary
<blockquote>Context for providing ResourceConfig to client components throughout the component tree</blockquote>

@example
```tsx
import { ResourceConfigContext } from '@shared/config';

// Used internally by ResourceConfigProvider and useResourceConfig
const config = useContext(ResourceConfigContext);
```
 * @internal
 */
export const ResourceConfigContext = createContext<ResourceConfig | null>(null);
